'use client';

import React from 'react';

const AdvisoryRelevance = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-12">
            <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-6 leading-tight">
              Advisory Relevance for Boards and Leadership Teams
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 font-body leading-relaxed">
              As organisations navigate AI-driven change, boards and executive teams increasingly face questions that extend beyond technology — questions of leadership readiness, organisational risk, pace of change, and long-term capability.
            </p>
            <p className="text-lg text-gray-700 font-body leading-relaxed">
              AI Change Leaders informs these discussions by articulating the principles, language, and systems that forward-looking boards and leadership teams use to govern AI change responsibly and effectively.
            </p>
            <p className="text-lg text-gray-700 font-body leading-relaxed">
              Where appropriate, this perspective may be applied through advisory conversations focused on readiness, alignment, and organisational capability — grounded in the discipline of AI Change Leadership rather than project delivery.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvisoryRelevance;